// src/features/services/ttlock/api/rooms.ts
import { getCookie } from '../../../../lib/http/bffClient';

export type CreateRoomInput = {
  name: string;
  lockId: number;
  notes?: string | null;
  roomNumber?: number;
  isActive?: boolean;
  isAvailable?: boolean;
};

export async function createRoom(input: CreateRoomInput): Promise<{ id_scope: number }> {
  const csrf = getCookie('csrf');
  const res = await fetch('/bff/ttlock/rooms', {
    method: 'POST',
    credentials: 'include',
    headers: {
      accept: 'application/json',
      'content-type': 'application/json',
      ...(csrf ? { 'X-CSRF': csrf } : {}),
    },
    body: JSON.stringify(input),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(text || `POST /bff/ttlock/rooms → ${res.status}`);
  }
  return res.json();
}

/** POST /bff/ttlock/rooms/:roomNumber/active  { active: boolean } */
export async function toggleRoomActive(roomNumber: number, active: boolean): Promise<{ id_scope: number; active: boolean }> {
  if (!Number.isFinite(roomNumber)) throw new Error('Invalid room number');
  const csrf = getCookie('csrf');
  const res = await fetch(`/bff/ttlock/rooms/${roomNumber}/active`, {
    method: 'POST', // always POST (BFF inserts a new outcome row)
    credentials: 'include',
    headers: {
      accept: 'application/json',
      'content-type': 'application/json',
      ...(csrf ? { 'X-CSRF': csrf } : {}),
    },
    body: JSON.stringify({ active }),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(text || `POST /bff/ttlock/rooms/${roomNumber}/active → ${res.status}`);
  }
  return res.json();
}
